import clientConfig from '../../client.config';

export const getUrl = (path) => {

  return `${clientConfig.serverBaseUrl}${path}`;
};

export const doubleCheckForHttpsUri = (path) => {

  if (path.includes('https'))
    return path;
  console.log(path);
  return `https://${path}`;

};